import clsx from "clsx";
import React from "react";
import { Box, BoxProps, Typography, Popover } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {
  usePopupState,
  bindTrigger,
  bindPopover,
} from "material-ui-popup-state/hooks";
import { ClientCalendarProgramCard } from "../card/ClientCalendarProgramCard";
import { ClientEnrollmentDto, EnrollmentsForCalendarDto } from "@growth-machine-llc/stridist-api-client";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(0.75),
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme.palette.primary.main,
    width: "100%",
    textAlign: "center",
    cursor: "pointer",
    margin: theme.spacing(0.5),
  },

  name: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: "15px",
    color: theme.palette.common.white,
  },
}));

export interface CoachClientCalendarEnrollmentProps extends BoxProps {
  enrollment: EnrollmentsForCalendarDto;
  enrollments: EnrollmentsForCalendarDto[];
}

export function CoachClientCalendarEnrollment(
  props: CoachClientCalendarEnrollmentProps,
) {
  const { className, enrollment, enrollments, ...other } = props;
  const s = useStyles();

  const enrollmentState = usePopupState({
    variant: "popover",
    popupId: "enrollmentCard",
  });
  const enrollmentTriggerProps = React.useMemo(
    () => bindTrigger(enrollmentState),
    [enrollmentState],
  );
  const enrollmentPopoverProps = React.useMemo(
    () => bindPopover(enrollmentState),
    [enrollmentState],
  );

  const closeEnrollmentPopover = React.useCallback(() => {
    enrollmentState.close();
  }, [enrollmentState]);

  return (
    <Box className={clsx(s.root, className)} {...other}>
      <Typography
        className={s.name}
        children={enrollment.program.name}
        {...enrollmentTriggerProps}
      />
      <Popover {...enrollmentPopoverProps}>
        <ClientCalendarProgramCard
          enrollment={enrollment}
          enrollments={enrollments}
          onRemove={closeEnrollmentPopover}
          onChangeStartDate={closeEnrollmentPopover}
          onChangeProgram={closeEnrollmentPopover}
        />
      </Popover>
    </Box>
  );
}
